// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","891":"component---src-pages-tos-tsx","985":"component---src-pages-privacy-tsx"}[chunkId] + "-" + {"245":"7a08530a9872a787be52","891":"c0cbd6906cc0948a5441","985":"d18c12b75ec0edd3ae49"}[chunkId] + ".js";
};